import { render, staticRenderFns } from "./FeedContent.vue?vue&type=template&id=defe8012"
import script from "./FeedContent.vue?vue&type=script&lang=js"
export * from "./FeedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports